import { Button } from '@mui/material';

const LinkButton = props => (
  <Button
    {...props}
    variant='contained'
    color='primary'
    sx={{ mb: 1 }}
    target='_blank'
  >
    {props.text}
  </Button>
);

export default LinkButton;
